import Media from 'react-media';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import MoreVert from '@material-ui/icons/MoreVert';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import materialTheme from '../reactMaterialTheme';
import Mixpanel from '../shared/Mixpanel';
import http from '../shared/http';
import GroupOptionsDropdown from './GroupOptionsDropdown';
import GroupOptionsDrawer from './GroupOptionsDrawer';

const GroupOptions = props => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleIconClick = event => {
    Mixpanel.track('Opened Group Options Menu List');
    toggleDrawer();
    setAnchorEl(event.currentTarget);
  };

  const hideMenu = () => {
    setAnchorEl(null);
  };

  const handleViewContent = () => {
    Mixpanel.track('Clicked to View Group', {
      id: props.group.id
    });

    return props.$state.go('creativePreview.showPreviewGroup', {
      id: props.group.id
    });
  };

  const handleDelete = async () => {
    if (!confirm("Are you sure you want to delete this group?")) {
      return;
    }

    Mixpanel.track('Clicked to Delete Group', {
      id: props.group.id
    });

    await http.delete(`/preview_groups/${props.group.id}`);
    flashMessage('Group Successfully Deleted');
    props.CreativeListService.refreshList();
    hideMenu();
  };

  const handleEditAd = () => {
    Mixpanel.track('Clicked to Edit Group', {
      id: props.group.id
    });

    return props.$state.go('creativePreview.edit.group', {
      id: props.group.id
    });
  };

  const flashMessage = message => {
    props.FlashService.push('success', message);
  };

  const toggleDrawer = () => {
    setAnchorEl(null);
  };

  const commonProps = {
    isOpen: Boolean(anchorEl),
    hideMenu,
    handleViewContent,
    handleEditAd,
    handleDelete
  };

  return (
    <MuiThemeProvider theme={materialTheme}>
      <div className="dropdown inline ad-options">
        <button
          onClick={handleIconClick}
          aria-label="Actions"
          className="dropdown-button ad-options-button"
          data-testid="group-menu-button"
        >
          <MoreVert />
        </button>
        <Media query="(max-width: 800px)">
          {matches =>
            matches ? (
              <GroupOptionsDrawer {...commonProps} />
            ) : (
              <GroupOptionsDropdown anchorEl={anchorEl} {...commonProps} />
            )
          }
        </Media>
      </div>
    </MuiThemeProvider>
  );
};

GroupOptions.propTypes = {
  group: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  $state: PropTypes.object.isRequired,
  CreativeListService: PropTypes.object.isRequired,
  FlashService: PropTypes.object.isRequired
};

export default GroupOptions;
